/**
 * Create a anchor for a page heading
 * @param heading The heading
 * @returns The anchor
 */
export function createAnchor(heading) {
    if (!heading) {
        return '';
    }
    const anchor = heading.toLowerCase().replace(/[^a-z0-9]/g, "");
    return anchor;
}
